import { NONE_DROPDOWN_VALUES } from '@commons/constants/dropdown';

const getUniqueGroupsFromStores = (stores) => {
  const groupsById = stores.reduce((result, store) => {
    (store.groups ?? []).forEach((group) => {
      result[group.id] = group;
    });

    return result;
  }, {});

  return Object.values(groupsById);
};

/**
 * Build the group dropdown choices for a list of stores, prepending the special
 * "None" group when at least one store has no group.
 *
 * @param {Object[]} stores
 * @returns {Object[]} Group choices (may include the "None" group)
 */
export const getGroupsWithNoneFromStores = (stores) => {
  const groups = getUniqueGroupsFromStores(stores);
  const hasStoreWithoutGroup = stores.some((store) => !store.groups?.length);
  const noneGroup = NONE_DROPDOWN_VALUES().MASCULINE;

  if (!groups.length) {
    return [noneGroup];
  }

  if (!hasStoreWithoutGroup) {
    return groups;
  }

  return [noneGroup, ...groups];
};

/**
 * Build the group dropdown choices for recipe variant modals. Returns an empty
 * list when no store has a group, otherwise prepends the special "None" group
 * when at least one store has no group.
 *
 * @param {Object[]} stores
 * @returns {Object[]} Group choices (may include the "None" group)
 */
export const getSelectableGroupsFromStores = (stores) => {
  const groups = getUniqueGroupsFromStores(stores);

  if (!groups.length) {
    return [];
  }

  return getGroupsWithNoneFromStores(stores);
};
